export function runCrypto(mode:'encrypt'|'decrypt',blob:Blob,password:string,signal:AbortSignal,progress:(n:number)=>void):Promise<Blob>{
 return new Promise((resolve,reject)=>{
  const worker=new Worker(new URL('./crypto.worker.ts',import.meta.url),{type:'module'});
  const done=()=>{worker.terminate();signal.removeEventListener('abort',cancel);};
  const cancel=()=>{done();reject(new Error('操作已取消；原数据未替换。'));};
  signal.addEventListener('abort',cancel,{once:true}); if(signal.aborted){cancel();return;}
  worker.onmessage=e=>{if('progress' in e.data){progress(e.data.progress);return;}done();if(e.data.error)reject(new Error(e.data.error));else resolve(e.data.result);};
  worker.onerror=()=>{done();reject(new Error('加密 Worker 无法运行，未生成或恢复备份。'));};
  worker.postMessage({mode,blob,password});password='';
 });
}
